import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriaCreateInterface } from "../../interfaces/categoriaInterfaces/CategoriaCreate.interface";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import apiClient from "@/clients/apiClient";

export async function UpdateCategoriaProductoAction(
    categoriaId: string,
    updateData: Partial<CategoriaCreateInterface>
): Promise<ApiResponse<CategoriasProductoInterface>> {
    const { data } = await apiClient.patch<CategoriasProductoInterface>(  
        `gpCategoriasProducto/${categoriaId}`,
        updateData
    );
    return {
        status: 200,
        data,
        message: "Categoría de producto actualizada correctamente",
    };

}